import React, { useEffect, useState } from 'react';
import { Grid, Card, CardContent, Typography, CircularProgress, Box } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useFetch } from '../../../hooks/use-fetch';
import { BASE_ADMIN_API_URL } from '../../../config';

export default function UserDetails() {
    const { id } = useParams();
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const fetchWithAuth = useFetch();

    useEffect(() => {
        let cancelled = false;

        async function load() {
            try {
                const response = await fetchWithAuth(`${BASE_ADMIN_API_URL}/users/${id}`);
                if (!response.ok) throw new Error(await response.text());
                const data = await response.json();
                if (!cancelled) setUser(data);
            } catch (e) {
                console.error('Failed to load user', e);
            } finally {
                if (!cancelled) setLoading(false);
            }
        }

        load();
        return () => { cancelled = true; };
    }, [fetchWithAuth, id]);

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                <CircularProgress />
            </Box>
        );
    }

    if (!user) return null;

    return (
        <Card>
            <CardContent>
                <Grid container spacing={2}>
                    <Grid item xs={12}><Typography>{user.name || '—'}</Typography></Grid>
                    <Grid item xs={12}><Typography>{user.mail || '—'}</Typography></Grid>
                    <Grid item xs={12}><Typography>{user.auth_provider_id || 'No auth provider'}</Typography></Grid>
                    <Grid item xs={12}><Typography>{user.last_access ? new Date(user.last_access).toISOString() : '—'}</Typography></Grid>
                    <Grid item xs={12}><Typography>{new Date(user.created_at).toISOString()}</Typography></Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}
